module.exports = __webpack_public_path__ + "0f780a9e13188b71dcaf27cca650b847.png";